import { render, staticRenderFns } from "./copyrightWorksDisplayDetail.vue?vue&type=template&id=77f89488&scoped=true&"
import script from "./copyrightWorksDisplayDetail.vue?vue&type=script&lang=js&"
export * from "./copyrightWorksDisplayDetail.vue?vue&type=script&lang=js&"
import style0 from "./copyrightWorksDisplayDetail.vue?vue&type=style&index=0&id=77f89488&prod&lang=less&scoped=true&"
import style1 from "./copyrightWorksDisplayDetail.vue?vue&type=style&index=1&id=77f89488&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f89488",
  null
  
)

export default component.exports